// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { logout } from '../actions/accountActions';

import styles from '../styles/Header.scss';

type Props = {
  activeAccount: Object,
  logout: Function,
}

class HeaderComponent extends Component<Props> {
  render() {
    if (process.env.PUBLIC_URL == null) {
      return 'Improper setup';
    }

    const { name, credential } = this.props.activeAccount || {};
    return (
      <div className={styles.header}>
        <a className={styles.logoContainer} href="/">
          <img className={styles.logoImage} src={`${process.env.PUBLIC_URL}/logo.png`} />
        </a>
        <div className={styles.headerContent}>
          <div className={styles.logoutContainer}>
            <Link to="/account" className={styles.accountLink}>{name || '--'}, {credential || '--'}</Link>
            {' | '}
            <a className={styles.logoutButton} href='/' onClick={this.props.logout}>Logout</a>
          </div>
          <div className={styles.headerLinks}>
            <Link to="/monthlyReport">Monthly Report</Link>
            <Link to="/pharmacy">Pharmacy</Link>
            <Link to="/updates">Work List</Link>
            <Link to="/search">Patients</Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activeAccount: state.account.activeAccount,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
});

const Header = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderComponent);

export default Header;



// WEBPACK FOOTER //
// ./client/src/components/Header.jsx